import { useSelector } from 'react-redux';
import { LayoutType } from 'const';
import { CAROUSEL_STATIC_TYPES } from 'containers/Layouts/sagas/addCarousel';
import { isLayoutBeingUploaded } from 'containers/Layouts/selectors';
import { sections } from 'containers/Sections/selectors';
import { CombinedDocumentsMap, LayeredRelationsMap, LayoutMap } from 'models';
import * as Models from 'models';
import { isEmptyLayout } from 'utils/layouts/isLayoutEmpty';
import { isColumnRelation } from 'utils/relations/isColumnRelation';

export function isLayoutStretching(
  layout: LayoutMap,
  layoutRelations: LayeredRelationsMap | undefined,
  documents: CombinedDocumentsMap | undefined,
): boolean {
  if (!layoutRelations || !documents) {
    return false;
  }
  if (layout.get('type') === LayoutType.ABBREVIATIONS_LIST) {
    return false;
  }
  if (!isEmptyLayout(layout, layoutRelations, documents as unknown as Models.DocumentsMap)) {
    return false;
  }
  const relation = layoutRelations.get(layout.get('relationId'));
  if (!isColumnRelation(relation)) {
    return false;
  }
  const rowsHeight = relation.getIn(['styles', 'rowsHeight']);

  return !(rowsHeight?.every(Boolean) ?? false);
}

type Props = {
  disableDragAndDelete?: boolean;
  documents?: CombinedDocumentsMap;
  groupLayoutId?: string;
  isLastLayout?: boolean;
  layout: LayoutMap;
  layoutRelations?: LayeredRelationsMap;
};
export const useShouldDisableDragAndDeleteActions = (props: Props): boolean => {
  const {
    disableDragAndDelete,
    documents,
    isLastLayout,
    layout,
    layoutRelations,
    groupLayoutId,
  } = props;

  const carouselItem = layout.get('carouselItem');
  const carouselItemType = carouselItem?.get('type');
  const isStaticType = carouselItemType && CAROUSEL_STATIC_TYPES.includes(carouselItemType);

  const isGroupLayoutBeingUploaded = useSelector(isLayoutBeingUploaded(groupLayoutId));
  const sectionsMap = useSelector(sections);
  const sectionId = layout.get('section');
  const section = sectionsMap.get(sectionId);
  const carouselIds = section?.get('carouselIds');
  const hasCarouselInSection = carouselIds && carouselIds.size > 0;
  if (!carouselItemType && hasCarouselInSection && isLastLayout) {
    return false;
  }
  if (carouselItemType && isLastLayout) {
    return true;
  }

  return isStaticType ||
    isGroupLayoutBeingUploaded ||
    disableDragAndDelete ||
    (isLastLayout && layoutRelations && isEmptyLayout(layout, layoutRelations, documents));
};
